module.exports = __webpack_public_path__ + "img/xjbdcdjwsdx.f53ea6bd.png";